import { ListGuesser, EditGuesser, ShowGuesser } from "react-admin";

import ChallengeIcon from "@mui/icons-material/TrackChanges";

import ChallengeCreate from "./ChallengeCreate";
import ChallengeList from "./ChallengeList";
import ChallengeEdit from "./ChallengeEdit";

const ChallengeResourceProps = {
	name: "challenge",
	list: ChallengeList,
	create: ChallengeCreate,
	edit: ChallengeEdit,
	show: ShowGuesser,
};

export const ChallengeMenuProps = {
	to: "/challenge",
	primaryText: "Défis",
	icon: ChallengeIcon,
};

export default ChallengeResourceProps;
